module.exports = __webpack_public_path__ + "img/隨緣自強5.5 的副本.9aeccfad.jpg";